import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { AgrNotificationEmptyModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { BemProduct } from '../../../models';

@Component({
  selector: 'app-bem-products',
  imports: [
    MatTable,
    AgrI18nSharedModule,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    NgTemplateOutlet,
    DatePipe,
    AgrNotificationEmptyModule,
  ],
  templateUrl: './bem-products.component.html',
  styleUrl: './bem-products.component.css',
})
export class BemProductsComponent {
  products: InputSignal<BemProduct[]> = input<BemProduct[]>([]);

  isNotEmpty: Signal<boolean> = computed(() => this.products().length > 0);

  protected readonly displayedColumns = ['name', 'alreadyOrdered'];
}
